export const attachmentDropzoneStyles = {
	root: (isDraggingOver: boolean, clickable: boolean) => ({
		display: 'flex',
		alignItems: 'center',
		justifyContent: clickable ? 'flex-start' : 'center',
		columnGap: 3,
		rowGap: 3,
		height: 60,
		px: 1.5,
		'@media (max-width: 600px)': {
			px: 1
		},
		borderRadius: '4px',
		border: clickable ? '1px dashed' : 'none',
		borderColor: isDraggingOver ? 'primary.main' : 'grey.300',
		backgroundColor: isDraggingOver ? 'primary.hover' : 'grey.50',
		transition: 'background-color 120ms, border-color 120ms',
		cursor: clickable ? 'pointer' : 'default',
		outline: 'none',
		...(clickable &&
			!isDraggingOver && {
				'&:hover': {
					backgroundColor: 'primary.hover',
					borderColor: 'primary.main'
				},
				'&:hover [data-slot="helper-text"]': {
					color: 'text.secondary'
				},
				'&:hover [data-slot="upload-icon"]': {
					color: 'primary.main'
				}
			})
	}),
	browseSection: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 1.5
	},
	textStack: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.25
	},
	uploadIcon: {
		fontSize: 20,
		color: 'text.secondary',
		flexShrink: 0
	},
	browseSubtext: {
		fontSize: '0.75rem',
		fontWeight: 400,
		color: 'text.secondary'
	},
	helperText: (isDraggingOver: boolean) => ({
		fontSize: '0.75rem',
		fontWeight: 400,
		color: isDraggingOver ? 'text.secondary' : 'text.disabled'
	}),
	maxReachedText: {
		fontSize: '0.875rem',
		color: 'text.secondary',
		width: '100%',
		textAlign: 'center',
		whiteSpace: 'nowrap'
	},
	hiddenInput: {
		display: 'none'
	},
	errorList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5,
		mt: 1
	}
};
